import { v4 as uuidv4 } from 'uuid';
import { fileUpload } from 'features/common/file-request';
import { SportsSection, SportsSectionFull } from 'features/profile/sports/sections/types';
import { request } from '~/utils/request';
import { imageUploadCode } from '~/constants';

export const sportsSectionsRead = request.table<SportsSection>(async ({ api }) => {
  const res = await api.get<{ links: SportsSection[] }>('/api/admin/link/list?groupCode=sports_sections');
  if (res.error) {
    return {
      data: {
        rows: [],
        pagination: null,
      },
    };
  }

  return {
    data: {
      rows: res.data?.links,
      pagination: null,
    },
  };
});

export const sportsSectionGet = request.card<SportsSectionFull, SportsSectionFull>(
  async ({ api, data, parseError }) => {
    const res = await api.get<{ link: SportsSectionFull }>(`/api/admin/link/get?link=${data.id}`);
    if (res.error) {
      return { error: parseError(res.error) };
    }
    return {
      data: {
        ...res.data?.link,
        group: res.data?.link.group?.id as any,
      },
    };
  },
);

export const sportsSectionCreate = request.card<SportsSectionFull, SportsSectionFull>(
  async ({ api, parseError, data }) => {
    const id = uuidv4();

    const body = {
      ...data.data,
      id,
      type: 'bottomSheet',
      groupCode: 'sports_sections',
    };

    if (data.data.image) {
      const fileUploadRes = await fileUpload(
      id as string,
      (data.data.image as File[])[0],
      'link',
      imageUploadCode,
      'default',
      true,
      );

      if (fileUploadRes.error) {
        return {
          error: {
            message: '',
            fields: { image: fileUploadRes.error as unknown as string },
          },
        };
      }
      body.image = fileUploadRes.data?.id;
    } else {
      body.image = null;
    }

    const res = await api.post<{ link: SportsSectionFull }>('/api/admin/link/create', body);
    if (res.error) {
      return { error: parseError?.(res.error) };
    }
    return { data: res.data?.link };
  },
);

export const sportsSectionUpdate = request.card<SportsSectionFull, SportsSectionFull>(
  async ({ api, parseError, data }) => {
    const body = { ...data.data, link: data.id };

    if (data.data.image) {
      const fileUploadRes = await fileUpload(
      data.id as string,
      (data.data.image as File[])[0],
      'link',
      imageUploadCode,
      'default',
      true,
      );

      if (fileUploadRes.error) {
        return {
          error: {
            message: '',
            fields: { image: fileUploadRes.error as unknown as string },
          },
        };
      }
      body.image = fileUploadRes.data?.id;
    }

    const res = await api.patch<{ link: SportsSectionFull }>('/api/admin/link/update', body);
    if (res.error) {
      return { error: parseError?.(res.error) };
    }
    return { data: res.data?.link };
  },
);

export const sportsSectionDelete = request.card(async ({ api, data, parseError }) => {
  const res = await api.delete(`/api/admin/link/delete?link=${data.id}`);
  if (res.error) {
    return { error: parseError(res.error) };
  }
  return { data: 'ok' };
});
